import { css } from 'styled-components'
import { theme } from './theme'

// Shadows print as grey smudges, so cards get a hairline instead.
export const printCardOutline = css`
  @media print {
    box-shadow: none;
    border: 1px solid ${theme.color.beigeDark};
  }
`

// Short orange rule drawn above section titles in the printed report.
export const printAccentBar = css`
  display: block;
  width: 40px;
  height: 3px;
  border-radius: 2px;
  background-color: ${theme.color.orange};
  margin-bottom: ${theme.spacing.medium}px;
`
